import React, { ReactNode, useState } from 'react';
import ComWatermark from './ComWatermark';

interface TabProps {
    tabs: { label: string; content: React.ReactNode }[];
    defaultTabIndex?: number;
    icons?: ReactNode[];
    setOnTabID: React.Dispatch<React.SetStateAction<number>>;
}

const Tabs: React.FC<TabProps> = ({ tabs, icons, defaultTabIndex = 0, setOnTabID }) => {
    const [activeIndex, setActiveIndex] = useState(defaultTabIndex);

    return (
            <div className="w-full mt-4 bg-transparent dark:bg-transparent">
                <div className="flex border-b divide-x dark:border-b-sky-800 divide-dashed divide-gray-100 dark:divide-sky-800 justify-between border-gray-100 overflow-x-auto whitespace-nowrap">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => {setActiveIndex(index); setOnTabID(index)}}
                            className={`py-1 px-5 xl:w-full lg:w-full sm:px-4 xs:!px-5 flex justify-center flex-row gap-1.2 text-[12px] font-medium ${index === activeIndex
                                ? 'bg-green-500 text-white border-b-1 rounded-sm border-green-500'
                                : 'text-sky-900 dark:text-gray-300 hover:text-green-500'
                                }`}
                        >
                            {icons && icons[index] && <span className="my-auto mr-1 text-[18px]">{icons[index]}</span>} {/* Display icon */}
                            {tab.label}
                        </button>
                    ))}
                </div>
                <div className="py-4">
                    {tabs[activeIndex]?.content}
                </div>
            </div>
    );
};

export default Tabs;
